export const DEFAULT_APP_TITLE = 'Joomla Updater API'
export const APP_DESCRIPTION =
    'Die Joomla Updater API ist die zentrale Verwaltungsoberfläche für die Bereitstellung von Joomla-Updates.'
